module.exports = __webpack_public_path__ + "img/alipay.d47cda91.png";